// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

const toolbar = ['searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  undo redo removeformat subscript superscript code codesample | fontsizeselect | fontselect', 
'addOverBtn addMeasuredangleBtn addPiBtn addChiBtn addMultiplicationBtn addDivideBtn addPlusBtn addMinusBtn addRandomBtn addAsympBtn addFractionBtn addVariableBtn | addBrackets ｜ table image']
export default toolbar
